/**
 * Slider para tarjetas de experiencias en bici
 */

if (document.getElementById("bikeExperiencesCarousel")) {
  document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.getElementById("bikeExperiencesCarousel");
    const slideContainer = carousel.querySelector(".card-list");
    const prevSlideBtn = document.getElementById("prev-slide-bike");
    const nextSlideBtn = document.getElementById("next-slide-bike");
    const indicatorsContainer = document.getElementById("bike-indicators");

    if (!slideContainer || !prevSlideBtn || !nextSlideBtn || !indicatorsContainer) {
      return;
    }

    const cards = Array.from(slideContainer.querySelectorAll(".card-item"));
    const cardsPerSlide = 4;
    let currentSlide = 0;
    const totalSlides = Math.ceil(cards.length / cardsPerSlide);

    function getSlideWidth() {
      const containerWidth = slideContainer.parentElement.offsetWidth;
      return containerWidth;
    }

    function updateNavigation() {
      if (totalSlides <= 1) {
        prevSlideBtn.classList.add("p-hidden");
        nextSlideBtn.classList.add("p-hidden");
        indicatorsContainer.classList.add("p-hidden");
        indicatorsContainer.innerHTML = "";
        return;
      }

      indicatorsContainer.classList.remove("p-hidden");
      prevSlideBtn.classList.toggle("p-hidden", currentSlide === 0);
      nextSlideBtn.classList.toggle("p-hidden", currentSlide >= totalSlides - 1);

      indicatorsContainer.innerHTML = "";
      for (let i = 0; i < totalSlides; i++) {
        const indicator = document.createElement("span");
        indicator.classList.add(
          "indicator",
          "p-w-2",
          "p-h-2",
          "p-bg-gray-border",
          "p-rounded-full",
          "p-cursor-pointer"
        );

        if (i === currentSlide) {
          indicator.classList.add("active", "p-bg-primary");
        }

        indicator.addEventListener("click", function () {
          currentSlide = i;
          updateSlidePosition();
          updateNavigation();
        });

        indicatorsContainer.appendChild(indicator);
      }
    }

    function updateSlidePosition() {
      const slideWidth = getSlideWidth();
      slideContainer.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
    }

    prevSlideBtn.addEventListener("click", function () {
      if (currentSlide > 0) {
        currentSlide--;
        updateSlidePosition();
        updateNavigation();
      }
    });

    nextSlideBtn.addEventListener("click", function () {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        updateSlidePosition();
        updateNavigation();
      }
    });

    updateNavigation();
    updateSlidePosition();
    window.addEventListener("resize", updateSlidePosition);
  });
}
